import React, { useState } from 'react';
import { ContextualAlert, ViewIcon, DownloadIcon, IconButton } from '@paypalcorp/pp-react';
import styles from './Overlay.module.less';
import PropTypes from 'prop-types';
import './overlay.legacy.css';
import {
  trackModalError,
  trackModalShown,
  trackModalClosed,
  trackButtonClick
} from '../../lib/fpti';

// This component is being used here: https://developer.paypal.com/docs/checkout/#home
// TODO: Look to refactor this code to be consistent with current react component approach

const Overlay = ({ src, fileName, caption, imageHeight, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const downloadImage = async () => {
    fetch(src)
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => trackModalError(src, 'An error occurred downloading your file'));
  };

  return (
    <>
      <div
        className={`imageContainer ${className}`}
        style={{
          backgroundImage: `url("${src}")`,
          height: imageHeight,
          backgroundPosition: 'center',
          cursor: 'pointer'
        }}
      >
        <div className="imageContainerController">
          <ContextualAlert type="info" className="imageContainerAlert" style={{ color: 'white' }}>
            <p className="imageContainerCaption">{caption}</p>
          </ContextualAlert>
          <div className="imageContainerButtons">
            <IconButton
              className={styles.icon_button}
              buttonType="secondary"
              svgIconComponent={DownloadIcon}
              screenReaderText="Download Image"
              onClick={() => {
                downloadImage();
                trackButtonClick('Download', null, src);
              }}
            />
            <IconButton
              className={styles.icon_button}
              buttonType="secondary"
              svgIconComponent={ViewIcon}
              screenReaderText="View Image"
              onClick={() => {
                openModal();
                trackButtonClick('View');
                trackModalShown('View');
              }}
            />
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="overlay">
          <div className="overlayContent">
            <button
              type="button"
              className="closeButton"
              onClick={() => {
                closeModal();
                trackModalClosed('View');
              }}
            >
              &times;
            </button>
            {/* image is non-interactable so alt is kept empty for accessibility reasons  */}
            <img src={src} alt="" data-testid={caption} className="overlayImage" />
          </div>
        </div>
      )}
    </>
  );
};

IconButton.propTypes = {
  svgIconComponent: PropTypes.elementType.isRequired,
  onClick: PropTypes.func.isRequired
};

Overlay.propTypes = {
  src: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  imageHeight: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired
};

export default Overlay;
